export enum DisplayPreferences {
  RULES = 'show_rules',
  KEYWORDS = 'show_keywords',
}
